import { apiClient } from "model/axiosConfig";
import { ORDERSTATUS } from "constants/ordersStatus";
import { typeRequestPagination } from "model/system/constants";
import {
  typeOrdersFilters,
  typeOrdersProductList,
} from "model/dashboardOrders/dOrdersReducer";

// Type

export type typeNewOrderRequest = {
  storeId: string;
  customerName: string;
  phone: string;
  address: string;
  comment?: string;
  collectorId?: string | null;
  courierId?: string | null;
  discount: typeOrdersProductList["discount"];
  servicePayment: typeOrdersProductList["servicePaymentAmount"];
  orderedProducts: typeOrdersProductList["productList"];
  status: ORDERSTATUS.CREATED;
};

export type typeEditedOrderRequest = {
  id: string;
  storeId: string;
  customerName?: string;
  phone?: string;
  address?: string;
  comment?: string;
  collectorId?: string | null;
  courierId?: string | null;
  discount?: typeOrdersProductList["discount"];
  servicePayment?: typeOrdersProductList["servicePaymentAmount"];
  orderedProducts?: typeOrdersProductList["productList"];
  status?: string;
};

export type typeOrdersRequestFilters = {
  filters: {
    dateCreated?:
      | {
          from: string;
          to: string;
        }
      | {};
    address?: string | string[] | null;
    customerName?: string | string[] | null;
    courierId?: string | null;
    status?: string | null;
    number?: number | null;
    saleId?: string | string[] | null;
    externalId?: string | null;
    or?: {
      number?: number;
      externalId?: string[];
    };
    id?: string | string[];
  };
  full?: boolean;
  sortFilter?: {
    direction: string;
    column: string;
  };
  pageFilter?: typeRequestPagination;
};

// Get Orders list
export const getOrdersList = async (payload: {
  filters: typeOrdersFilters;
  paginationRequest: typeRequestPagination;
}) => {
  const path = "/product/orders/v2/slim/search";
  const config = {
    headers: {},
  };
  const data: typeOrdersRequestFilters = {
    filters: {},
    full: true,
    sortFilter: {
      direction: "DESC",
      column: "dateCreated",
    },
    pageFilter: payload.paginationRequest,
  };

  if (payload.filters.number) data.filters.number! = +payload.filters.number;
  if (payload.filters.address) data.filters.address = [payload.filters.address];
  if (payload.filters.client)
    data.filters.customerName = [payload.filters.client];
  if (payload.filters.status) data.filters.status = payload.filters.status;
  if (payload.filters.dateCreated) {
    data.filters.dateCreated! = payload.filters.dateCreated;
  }
  if (payload.filters.courierId)
    data.filters.courierId = payload.filters.courierId;
  if (payload.filters.saleId) data.filters.saleId = [payload.filters.saleId];
  if (payload.filters.externalId)
    data.filters.externalId = payload.filters.externalId;
  if (payload.filters.searchString) {
    const or: typeOrdersRequestFilters["filters"]["or"] = {};
    const isNumber = !isNaN(Number(payload.filters.searchString));
    if (isNumber) {
      or.number = Number(payload.filters.searchString);
    }
    or.externalId = [payload.filters.searchString];
    data.filters.or = or;
  }

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    if (error.response) {
      console.log(error);
      return error.response;
    } else if (error.request) {
      console.log(error);
      return error.request;
    } else {
      console.log(error);
      return error;
    }
  }
};

// Add ticket item
export const addOrdersItem = async (payload: {
  dataObject: typeNewOrderRequest;
}) => {
  const path = "/order/orders";
  const config = {
    headers: {},
  };
  const data = payload.dataObject;

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    if (error.response) {
      console.log(error);
      return error.response;
    } else if (error.request) {
      console.log(error);
      return error.request;
    } else {
      console.log(error);
      return error;
    }
  }
};

// Change status Orders item
export const changeOrdersItem = async (payload: {
  dataObject: typeEditedOrderRequest;
}) => {
  const path = "/order/orders";
  const config = {
    headers: {},
  };
  const data = payload.dataObject;

  try {
    return await apiClient.patch(path, data, config);
  } catch (error) {
    return error;
  }
};

// Get Sale by sale Id
export const getSaleById = async (payload: { saleId: string }) => {
  const path = `/product/sale/${payload.saleId}`;

  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Bulk patch

// Get Sale by sale Id
export const patchBulkOrders = async (payload: {
  data: { id: string; status: string }[];
}) => {
  const path = "/order/orders/bulk";

  const config = {
    headers: {},
  };

  try {
    return await apiClient.patch(path, payload.data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// get full order by ID
export const getFullOrderById = async (payload: { orderId: string }) => {
  const path = `/product/orders/${payload.orderId}/full`;

  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const exportOrdersListWithFilters = async (payload: {
  lang: string;
  selectedOrderIds?: string[];
  filters?: typeOrdersFilters;
}) => {
  const path = payload.lang
    ? `/product/api/v1/order/export/filter?lang=${payload.lang}`
    : `/product/api/v1/order/export/filter`;

  const config: { headers: {} } = {
    headers: {},
  };

  const data: typeOrdersRequestFilters = {
    filters: {},
    sortFilter: {
      direction: "DESC",
      column: "dateCreated",
    },
  };

  if (payload.filters) {
    if (payload.filters.address) {
      data.filters.address = payload.filters.address;
    }

    if (payload.filters.status) {
      data.filters.status = payload.filters.status;
    }

    if (payload.filters.courierId) {
      data.filters.courierId = payload.filters.courierId;
    }

    if (payload.filters.client) {
      data.filters.courierId = payload.filters.client;
    }

    if (payload.filters.externalId) {
      data.filters.courierId = payload.filters.externalId;
    }

    if (payload.filters.searchString) {
      data.filters.or = {
        externalId: [payload.filters.searchString],
        number: Number(payload.filters.searchString) || void 0,
      };
    }

    if (payload.filters.dateCreated?.from) {
      if (!data.filters.dateCreated) {
        data.filters.dateCreated = {
          from: payload.filters.dateCreated.from,
        };
      } else {
        (data.filters.dateCreated as any).from =
          payload.filters.dateCreated.from;
      }
    }

    if (payload.filters.dateCreated?.to) {
      if (!data.filters.dateCreated) {
        data.filters.dateCreated = {
          to: payload.filters.dateCreated.to,
        };
      } else {
        (data.filters.dateCreated as any).to = payload.filters.dateCreated.to;
      }
    }
  }

  if (payload.selectedOrderIds) {
    data.filters = { id: payload.selectedOrderIds };
  }

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
